import { Suspense } from 'react';
import { CalendarGrid } from './CalendarGrid';
import { CalendarHeader } from './CalendarHeader';
import { CalendarProvider } from '@/domain/termine/features/Calendar/shared/CalendarProvider';
import { Skeleton } from '@/components/ui/skeleton';

export function Calendar() {
  return (
    <div className="grid gap-1">
      <CalendarHeader />
      <Suspense fallback={<Skeleton className="h-screen w-full" />}>
        <CalendarProvider>
          <div className="bg-neutrals-N100 rounded-xl">
            <CalendarGrid />
          </div>
        </CalendarProvider>
      </Suspense>
    </div>
  );
}
